import { render, staticRenderFns } from "./EditWebchat.vue?vue&type=template&id=6d849c51&"
import script from "./EditWebchat.vue?vue&type=script&lang=js&"
export * from "./EditWebchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports